import { Form, Modal, Table } from "antd";
import React, { useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import DownloadTableComponent from "../../JobModuleComponent/DownloadTableComponent/DownloadTableComponent";
import DownloadTableColumn from "../../JobModuleComponent/DownloadTableComponent/DownloadTableColumn";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { get } from "lodash";
import { getDownloadPack } from "../../../redux/Transcribe/TranscribeAction";
interface DownloadModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function DownloadModal(props: DownloadModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const downloadModalState = useSelector((state: RootState) => state.TranscribeState.getDownloadDataState);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const DownloadModalContent = () => {
    return (
      <div className="body-container gap-3">
        <h3>Download</h3>
        <div className="d-flex justify-content-between">
          <DownloadTableComponent
            columns={DownloadTableColumn}
            dataSource={downloadModalState.data}
            loading={downloadModalState.loading}
            tableKey={"DownloadModalTable"}
          />
        </div>{" "}
      </div>
    );
  };

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        loading={downloadModalState.loading}
        width={1000}
        onCancel={handleModalClose}
        open={props.openState}>
        <DownloadModalContent />
      </Modal>
    </div>
  );
}

export default DownloadModal;
